import React from 'react'
import { Link } from 'react-router-dom'
import { Button, IconButton, Typography } from '@material-ui/core'
import {
  FavoriteBorder as FavoriteBorderIcon,
  LocationOnOutlined as LocationOnOutlinedIcon,
  Share as ShareIcon
} from '@material-ui/icons'
import noImage from 'assets/img/no-image.jpg'
import clsx from 'clsx'
import moment from 'moment'
import { ROUTES } from 'routes'
import { getDateEventFormat } from 'utils/functions'

import useStyles from './EventCard.style'

const EventCard = ({ event, previous, altMode }) => {
  const classes = useStyles()
  const {
    isSuspended,
    hasResults,
    externalInscriptionUrl,
    from,
    to,
    disciplines,
    slugUrl,
    countryName,
    areaLevel1Name,
    address,
    latitude,
    organization,
    name,
    longitude
  } = event
  const fromLocal = moment(from)
  const toLocal = moment(to)
  const canJoin = moment(from) > moment() // TODO: Add this feature to the backend
  const imageUrl =
    Array.isArray(event.profileImages) && event.profileImages.length > 0
      ? event.profileImages[0]
      : noImage
  const countDisciplines = disciplines.length - 3
  const disciplinesToShow =
    countDisciplines <= 0
      ? disciplines
      : [
          ...disciplines.slice(0, 3),
          {
            id: 'add',
            name: `Y ${countDisciplines} más`,
            title: disciplines
              .map((e) => e?.name)
              .slice(3, disciplines.length)
              .join(', ')
          }
        ]
  const showInscriptionButton =
    event && !hasResults && canJoin && !isSuspended && !!externalInscriptionUrl

  const hasCoords = latitude !== 0 && longitude !== 0

  const locationEvent = [countryName, areaLevel1Name, address]
    .filter(Boolean)
    .join(', ')
    .concat(`. ${!hasCoords ? ' La ubicación exacta se informará próximamente' : ''}`)

  return (
    <Link
      className={clsx(classes.container, previous && classes.simpleContainer, altMode && 'alt')}
      to={`${ROUTES.EVENTS.PROFILE}/${slugUrl}`}>
      <div className={clsx(classes.cardHeader, altMode && 'alt')}>
        <div className={clsx(classes.date, isSuspended && 'suspended')}>
          {getDateEventFormat(fromLocal, toLocal)}
        </div>
        {!previous && (
          <div className={clsx(classes.sportsContainer, altMode && 'alt')}>
            {disciplines.map((d) => (
              <div
                className={clsx(classes.sport, isSuspended && 'suspended')}
                key={d.id}
                title={d.name}>
                {d.name}
              </div>
            ))}
          </div>
        )}
      </div>
      {!previous && (
        <div
          className={clsx(classes.imageContainer, altMode && 'alt')}
          style={{
            backgroundImage: `url(${imageUrl})`
          }}>
          {isSuspended && (
            <div className={classes.containerSuspended}>
              <Typography className={classes.textSuspended}>
                EVENTO SUSPENDIDO POR EL ORGANIZADOR
              </Typography>
            </div>
          )}
        </div>
      )}
      <div
        className={clsx(
          classes.bodyContainer,
          previous && classes.simpleBodyContainer,
          altMode && 'alt'
        )}>
        <div className={clsx(classes.bodyHeader, altMode && 'alt')}>
          <div className={clsx(classes.date, isSuspended && 'suspended')}>
            {getDateEventFormat(fromLocal, toLocal)}
          </div>
          {!previous && (
            <div className={classes.sportsContainer}>
              {disciplinesToShow.map((d) => (
                <div
                  className={clsx(classes.sport, isSuspended && 'suspended', d.title && 'add')}
                  key={d.id}
                  title={d.name}>
                  {d.name}
                </div>
              ))}
            </div>
          )}
        </div>
        <h2
          className={clsx(classes.title, isSuspended && 'suspended', altMode && 'alt')}
          title={name}>
          {name}
        </h2>
        {!previous && (
          <div className={clsx(classes.location, isSuspended && 'suspended')} title={locationEvent}>
            <LocationOnOutlinedIcon />
            {locationEvent}
          </div>
        )}
        {!previous && (
          <div className={clsx(classes.organizer, isSuspended && 'suspended')}>
            {organization && organization.name}
          </div>
        )}

        {!previous && (
          <div className={classes.iconButtonsContainer}>
            <IconButton
              color='primary'
              className={clsx(classes.actionIconButton, isSuspended && 'suspended')}
              title='Me gusta'>
              <FavoriteBorderIcon />
            </IconButton>
            <IconButton
              color='primary'
              className={clsx(classes.actionIconButton, isSuspended && 'suspended')}
              title='Compartir'>
              <ShareIcon />
            </IconButton>
          </div>
        )}
      </div>
      <div className={clsx(classes.actions, previous && !altMode && 'alt')}>
        <div className={classes.actionButtonsContainer}>
          {event && hasResults && (
            <Button
              color='primary'
              variant='outlined'
              className={clsx(classes.actionButton, isSuspended && 'suspended', previous && 'alt')}>
              Resultados
            </Button>
          )}
          {showInscriptionButton && (
            <Button
              color='primary'
              variant='outlined'
              className={clsx(classes.actionButton, isSuspended && 'suspended')}>
              Inscribirse
            </Button>
          )}
        </div>
      </div>
    </Link>
  )
}

export default EventCard
